// Реквизиты оператора персональных данных и контакты — одно место для политики,
// согласия, подвала и страницы контактов
// Точка производства — корпус «Крандетальсервис» на ул. Зверева, 22 (выбрал владелец 29.10.2026,
// сверено с Яндекс Картами). Прежняя точка стояла на соседнем заводе им. Королёва
const LAT = 57.00698;
const LON = 40.9618;
const MAP_POINT = `${LON},${LAT}`;

export const COMPANY = {
  brand: 'РПСО',
  operator: 'Индивидуальный предприниматель Ветюгов Александр Евгеньевич',
  // Для «даю согласие кому»
  operatorDative: 'Индивидуальному предпринимателю Ветюгову Александру Евгеньевичу',
  operatorShort: 'ИП Ветюгов А. Е.',
  ogrnip: '309370311400012',
  inn: '370306522455',
  address: 'г. Иваново, ул. Зверева, 22',
  city: 'Иваново',
  cityPrepositional: 'Иванове',
  // Производство на карте поставок
  geo: { lat: LAT, lon: LON },
  mapEmbedUrl: `https://yandex.ru/map-widget/v1/?ll=${MAP_POINT}&pt=${MAP_POINT},pm2rdm&z=16&scroll=false`,
  mapUrl: 'https://yandex.ru/maps/5/ivanovo/house/ulitsa_zvereva_22/YEkYfwFjSUIPQFttfXxxdHxiYQ==/',
  phone: '+7 (901) 691-66-33',
  phoneHref: 'tel:+79016916633',
  email: 'sport37@inbox.ru',
  site: 'https://rpso.site',
} as const;

/** Редакция политики и согласия — меняется при каждой правке текстов, уходит в заявку как доказательство согласия */
export const PD_DOCS_VERSION = '29.10.2026 (ред. 8)';
